<template>
  <div :class="{ '-read': notification.is_read, '-message-on': isExpanded }">
    <div v-if="notification.from_user" class="fb-notification-user">
      <div class="avatar-container">
        <span v-if="notification.from_avatar_url" class="avatar-image"
          ><img class="author-image" :src="notification.from_avatar_url"
        /></span>

        <span v-else class="avatar-image">
          <div class="avatar-placeholder demi">
            <span>{{ notification.from_user.display_name.charAt(0) }}</span>
          </div>
        </span>
      </div>
    </div>
    <div class="fb-notification-content">
      <h3 class="byline demi">
        {{ notification.time_ago }}
      </h3>
      <div class="notification-title">
        <a :href="notification.url" class="no-hover" @click="markRead">{{ notification.title }}</a>
      </div>
      <!-- eslint-disable vue/no-v-html -->
      <div class="notification-body" v-html="notification.body" />
      <!-- eslint-enable vue/no-v-html -->
      <div class="notification-actions">
        <ul>
          <li class="view">
            <a :href="notification.url" @click="markRead">View</a>
          </li>
          <li class="mark">
            <a href="#" class="mark-notification" @click.prevent="markUnreadAndCollapse"
              >Mark Unread</a
            >
          </li>
          <li class="delete">
            <a href="#" @click.prevent="deleteNotification">Delete</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="fb-notification-expand">
      <button class="toggle-plus-minus" :class="{ active: isExpanded }" @click="toggleExpanded" />
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line
  props: ['notification'],
  data() {
    return {
      isExpanded: false,
    }
  },
  methods: {
    toggleExpanded() {
      if (!this.isExpanded && !this.notification.is_read) {
        this.markRead()
      }
      this.isExpanded = !this.isExpanded
    },

    markUnreadAndCollapse(e) {
      this.setIsRead(false)
      this.isExpanded = false
    },

    deleteNotification() {
      this.$emit('delete-notification', this.notification)
    },

    markRead() {
      // note: this call doesn't wait for response if done on a link
      if (!this.notification.is_read) {
        this.setIsRead(true)
      }
    },

    // mark read or unread
    setIsRead(newState: boolean) {
      this.$emit('set-notification-is-read', this.notification.id, newState)
    },
  },
}
</script>
